import React from "react";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import UploadDocument from "./upload";
import DownloadDocument from "./download";
import Security from "../../components/security";

class Documents extends ScreenComponent {
    render() {
        return (
            <section>
                <UploadDocument/>
                <hr style={{marginBottom: "4rem"}}/>
                {Security.getUser().isBlocked === false && <DownloadDocument/>}
            </section>
        );
    }
}

export default withRouter(Documents);